/**
 * @flow
 * @relayHash ba9d1a24cba3d4973967420e33bd73c1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventCalendarContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type EventCalendarQuery_UserEvent_Refetch_QueryVariables = {|
  visibility?: ?$ReadOnlyArray<?UserEventVisibility>,
  booking_status?: ?$ReadOnlyArray<?BookingStatus>,
|};
export type EventCalendarQuery_UserEvent_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventCalendarContainer_viewer$ref
  |}
|};
export type EventCalendarQuery_UserEvent_Refetch_Query = {|
  variables: EventCalendarQuery_UserEvent_Refetch_QueryVariables,
  response: EventCalendarQuery_UserEvent_Refetch_QueryResponse,
|};
*/


/*
query EventCalendarQuery_UserEvent_Refetch_Query(
  $visibility: [UserEventVisibility]
  $booking_status: [BookingStatus]
) {
  viewer {
    ...EventCalendarContainer_viewer_24sXjm
    id
  }
}

fragment EventCalendarContainer_viewer_24sXjm on User {
  id
  calendar_token
  s_time_zone
  ...AvailabilityCalendarContainer_viewer_1Ki8vT
  EventCalendar_user_events: user_events(visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        user_event_segments(first: 99999) {
          edges {
            node {
              all_day
              title
              start_at
              end_at
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer_1Ki8vT on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "visibility",
    "type": "[UserEventVisibility]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "booking_status",
    "type": "[BookingStatus]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "booking_status",
  "variableName": "booking_status",
  "type": "[BookingStatus]"
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 99999,
  "type": "Int"
},
v4 = {
  "kind": "Literal",
  "name": "return_empty_connection",
  "value": true,
  "type": "Boolean"
},
v5 = {
  "kind": "Variable",
  "name": "visibility",
  "variableName": "visibility",
  "type": "[UserEventVisibility]"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "event",
  "storageKey": null,
  "args": null,
  "concreteType": "Event",
  "plural": false,
  "selections": [
    v1,
    v6
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "booking_status",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v11 = [
  v3
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "all_day",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "EventCalendarQuery_UserEvent_Refetch_Query",
  "id": null,
  "text": "query EventCalendarQuery_UserEvent_Refetch_Query(\n  $visibility: [UserEventVisibility]\n  $booking_status: [BookingStatus]\n) {\n  viewer {\n    ...EventCalendarContainer_viewer_24sXjm\n    id\n  }\n}\n\nfragment EventCalendarContainer_viewer_24sXjm on User {\n  id\n  calendar_token\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer_1Ki8vT\n  EventCalendar_user_events: user_events(visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              all_day\n              title\n              start_at\n              end_at\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer_1Ki8vT on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: $visibility, booking_status: $booking_status, return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "EventCalendarQuery_UserEvent_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventCalendarContainer_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "booking_status",
                "variableName": "booking_status",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "visibility",
                "variableName": "visibility",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventCalendarQuery_UserEvent_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "calendar_token",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCalendarContainer_user_events",
            "name": "user_events",
            "storageKey": null,
            "args": [
              v2,
              v3,
              v4,
              v5
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEvent",
                    "plural": false,
                    "selections": [
                      v7,
                      v8,
                      v9,
                      v10,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event_segments",
                        "storageKey": "user_event_segments(first:99999)",
                        "args": v11,
                        "concreteType": "UserEventSegmentConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegmentEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [
                                  v6,
                                  v9,
                                  v10,
                                  v12,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "location",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "room",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v1
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v1
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "EventCalendar_user_events",
            "name": "user_events",
            "storageKey": null,
            "args": [
              v2,
              v4,
              v5
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEvent",
                    "plural": false,
                    "selections": [
                      v7,
                      v8,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event_segments",
                        "storageKey": "user_event_segments(first:99999)",
                        "args": v11,
                        "concreteType": "UserEventSegmentConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegmentEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [
                                  v12,
                                  v6,
                                  v9,
                                  v10,
                                  v1
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v1
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8fcf5d8eb6cdb32a2cb7b051d5b8b96f';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/EventCalendarQuery_UserEvent_Refetch_Query.graphql.js